export const focus = {
  inserted(el, binding) {
    if (binding.value !== false && el.checkVisibility()) el.focus();
  },
};

// this list is not exhaustive but limited to our use cases
export const FOCUSABLE_ELEMENTS =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function findFocusableElements(target) {
  const focusableElements = target.querySelectorAll(FOCUSABLE_ELEMENTS);
  const firstVisibleElement = findFirstVisibleElement(focusableElements);
  const lastVisibleElement = findLastVisibleElement(focusableElements);
  return {
    first: firstVisibleElement,
    last: lastVisibleElement,
  };
}

function findFirstVisibleElement(elements) {
  return [...elements].find((el) => el.checkVisibility()) || null;
}

function findLastVisibleElement(elements) {
  return findFirstVisibleElement([...elements].reverse()) || null;
}

function handleKeydown(e, target) {
  if (!(e.key === 'Tab' || e.keyCode === 9)) return;
  const { first, last } = findFocusableElements(target);
  if (e.shiftKey) {
    if (document.activeElement === first && last) {
      last.focus();
      e.preventDefault();
    }
  } else if (document.activeElement === last && first) {
    first.focus();
    e.preventDefault();
  }
}

// TODO: add escape key here?
export const trapFocus = {
  bind(el) {
    document.addEventListener(
      'keydown',
      (el._handleKeydown = (e) => handleKeydown(e, el))
    );
  },
  unbind(el) {
    document.removeEventListener('keydown', el._handleKeydown);
  },
  inserted(el) {
    findFocusableElements(el).first?.focus();
  },
};
